import React, { useEffect, useState } from "react";
 
import { useNavigate, useParams } from "react-router-dom";
import NoticeDetails from "./NoticeDetails";

import { useKeycloak } from "@react-keycloak/web";
import { yupResolver } from '@hookform/resolvers/yup';
import NoticeDetailsPreview from "./NoticeDetailsPreview";
import { Button } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
// import { toast } from "react-toastify";
import { useCreateUpdateNoticeDemandeMutation, useFetchNoticeDemandeQuery, useFetchNoticeQuery } from "../../../redux/slice/api/FO/noticeApi";
import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import Label from "../../../components/forms/Label";
import TextInput from "../../../components/forms/TextInput";
import { ModificationBloque, Notice_Demande_Modification_Etat, disponibiliteList, validationMode } from "../../../config/helpers";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import { IFormNoticeModifAuto } from "../../../models/interfaces/IFormNoticeModifAuto";
import SelectInput from "../../../components/forms/SelectInput";
import DatePickerInput from "../../../components/forms/DatePickerInput";
import { INoticeDemandeChampCreateUpdate, INoticeDemandeReturn, INoticeDetails } from "../../../models/interfaces/INotice";
import { toast } from "react-toastify";
import { format } from 'date-fns';
import ConfirmDialog from "../components/ConfirmDialog";

import { DemandeNoticeAutoSchema } from "../../../models/schema/DemandeNoticeAutoSchema";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";
import { formatDate2 } from "../../../utils/helpers";
import CpntNavigatorNotice from "../components/CpntNavigatorNotice";

 
const PageNoticeDetailsModifAuto: React.FC = () => {
  const [Actif, setActif] = useState(false);
  //
  const [demande, setDemande] = useState<INoticeDemandeReturn|null>(null);
  const [demandeIdEtat, setDemandeIdEtat] = useState<number|null>(null);
  const [demandeBloque, setDemandeBloque] = useState(true);
  const [demandeBloqueLivreEnMain, setDemandeBloqueLivreEnMain] = useState(false);
  const [notice, setNotice] = useState<INoticeDetails|undefined>(undefined);
  const [isDialogOpen, setDialogOpen] = useState(false);



  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const navigate = useNavigate();
  const { ean, idnotice,iddemande } = useParams();
 
  const [eanValue, setEanValue] = useState(ean || "");
  const [idNoticeValue, setIdNoticeValue] = useState(idnotice || "");
  const [idDemandeValue, setIdDemandeValue] = useState(
    iddemande && !isNaN(Number(iddemande)) ? Number(iddemande) : 0
  );
  const [pathSource, setPathSource] = useState<string>("");


  useEffect(() => {
    if (ean) {
       setEanValue(ean);
    }
    if (idnotice) { 
      setIdNoticeValue(idnotice);
    }
    if (iddemande && !isNaN(Number(iddemande))) {
      setIdDemandeValue(Number(iddemande));
    }

  }, [ean, idnotice, iddemande]); 


  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean); // Supprime les éventuels espaces vides

    if (pathParts.length >= 1 ) {
      setPathSource(`/${pathParts[0]}`);

      }
  }, [location.pathname, navigate]);



  const { data: NoticeResult, isFetching: isFetchingNotice,error: Noticeerror } = useFetchNoticeQuery({ EAN: eanValue , IdNotice: idNoticeValue }, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || eanValue === ""|| eanValue === undefined || idNoticeValue === "" || idNoticeValue === undefined,
  });
  
  const { data: NoticeDemandeResult, isFetching: isFetchingNoticeDemande ,error: NoticeDemandeerror} = useFetchNoticeDemandeQuery({IdDemande:idDemandeValue,EAN:eanValue ,IdNotice:idNoticeValue }, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || eanValue === ""|| eanValue === undefined|| idNoticeValue === "" || idNoticeValue === undefined || notice === undefined,
  });

   

  const formMethods = useForm<IFormNoticeModifAuto>({
    defaultValues: {
      hauteur: "",
      largeur: "",
      epaisseur: "",
      poids: "",
      nbpages: "",
      disponibilite: "",
      prixttc: "",
      dateparution: "",

      // Champs `New` obligatoires
      hauteurNew: "",
      largeurNew: "",
      epaisseurNew: "",
      poidsNew: "",
      nbpagesNew: "",
      disponibiliteNew:"",
      prixttcNew: "",
      dateparutionNew: null,
    }, 
    // mode: "onChange",
    // reValidateMode: "onChange",
    mode: "all",
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: yupResolver(DemandeNoticeAutoSchema),
  });

  const { handleSubmit,reset,formState: {errors, isValid },trigger,watch } = formMethods;
 

  const detail = () => {
    setActif(!Actif);
  }

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      //
    }
    
    if (errors.ErreurMsg?.message && errors.ErreurMsg?.message?.length > 0) {
      toast.error(<div dangerouslySetInnerHTML={{ __html: errors.ErreurMsg?.message }} />,{autoClose:5000});
    }
  }, [errors])



//Liste des champs liés
const disponibiliteNew = watch('disponibiliteNew');
const dateparutionNew = watch('dateparutionNew');
useEffect(() => {
  trigger(['disponibiliteNew', 'dateparutionNew', 'prixttcNew']);
}, [dateparutionNew, disponibiliteNew]);
///





  const ModificationAutoBloqueMessage = ModificationBloque(
    NoticeResult?.NoticeDetails?.Source ?? "",
    NoticeResult?.NoticeDetails?.Support?.supportId ?? "",
    "Modifcations automatisés impossible pour cette notice.");

  
  
    useEffect(() => {
      NoticeResult && setNotice(NoticeResult?.NoticeDetails);
      if (NoticeResult?.NoticeDetails) {
        const livreEnMain = NoticeResult?.NoticeDetails?.LivreEnMain;
          if (livreEnMain !== undefined) {
            setDemandeBloqueLivreEnMain(livreEnMain);
          } else {
            const idEtat = NoticeDemandeResult?.Demande?.IdEtat;
            if (idEtat) {
              setDemandeBloqueLivreEnMain(idEtat !== Notice_Demande_Modification_Etat.Cree);
            } else {
              setDemandeBloqueLivreEnMain(false);
            }
          }
      }
    }, [NoticeResult])



  useEffect(() => {
    if (NoticeDemandeResult) {
      setDemande(NoticeDemandeResult);
      setDemandeIdEtat(NoticeDemandeResult?.Demande?.IdEtat ? NoticeDemandeResult?.Demande?.IdEtat : null);
      setDemandeBloque(NoticeDemandeResult?.Demande?.IdEtat ? NoticeDemandeResult?.Demande?.IdEtat !== Notice_Demande_Modification_Etat.Cree : false);
    }
}, [NoticeDemandeResult])
  const [
    CreateUpdateNoticeDemandeMutation,
    {
    //isSuccess: isSuccessCreatedemandeMessage,
    error: errorCreateUpdateNoticeDemandeMutation,
    reset: resetCreateUpdateNoticeDemandeMutation
  }] = useCreateUpdateNoticeDemandeMutation();


  useEffect(() => {

    let resetValues = {};

    if (notice) {
      resetValues = {
        ...resetValues,
        hauteur: notice?.DesciptionPhysique?.hauteur?.toString() || "",
        largeur: notice?.DesciptionPhysique?.largeur?.toString() || "",
        epaisseur: notice?.DesciptionPhysique?.epaisseur?.toString() || "",
        poids: notice?.DesciptionPhysique?.poids?.toString() || "",
        nbpages: notice?.DesciptionPhysique?.nbPages || "",
        disponibilite: notice?.disponibiliteEtendue?.toString() || "",
        prixttc: notice?.prixTTC?.toString() || "",
        dateparution: notice?.dateParution || ""
      };
    }
    if (demande) {
      const dateparutionnew = demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "dateparution")?.ValeurDemande?.toString();

      let formattedDate = "";
      if (dateparutionnew !== undefined) {
        const originalDate = new Date(dateparutionnew);
        formattedDate = format(originalDate, formatDate2); //format accepté par datepicker
      }
     
      
      resetValues = {
        ...resetValues,
        hauteurNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "hauteur")?.ValeurDemande || "",
        largeurNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "largeur")?.ValeurDemande || "",
        epaisseurNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "epaisseur")?.ValeurDemande || "",
        poidsNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "poids")?.ValeurDemande || "",
        nbpagesNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "nbpages")?.ValeurDemande || "",
        disponibiliteNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "disponibilite")?.ValeurDemande || "",
        prixttcNew: demande?.Demande?.Champs?.find((c) => c.LibelleChamp.toLowerCase() === "prixttc")?.ValeurDemande || "",
        dateparutionNew: formattedDate,

       
      };
    }
      reset(resetValues);

  }, [notice,demande])

  if (NoticeDemandeerror || Noticeerror) {
    return (
      <div>Error</div>
    );
  } 
  
  // if (isFetchingNotice || isFetchingNoticeDemande) {
  //   return (
  //     <SpinnerEditeurPro />
  //   )
  // }

  const CreateUpdateNoticeDemande = async (champs: INoticeDemandeChampCreateUpdate[],suppression: boolean) => {

    const response = await CreateUpdateNoticeDemandeMutation(
      {
        Id:demande?.Demande?.Id,
        EAN:eanValue ?? "",
        IdNotice:idNoticeValue ?? "",
        Champs: champs ,
        NoticeMarques:notice?.Editeurs.map(e => Number(e.editeurId.replace(/^0-7/, ''))),
      }
    ).unwrap();
 
    if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      resetCreateUpdateNoticeDemandeMutation();
      response.Return_Message &&
      toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
    } else if (!isNaN(Number(response?.Demande?.Id))) {
      setDemande(response);
      resetCreateUpdateNoticeDemandeMutation();
      if (response?.Return_Message !== undefined && response?.Return_Message !== null && response?.Return_Message?.trim() !== "") {
        toast.success(<div dangerouslySetInnerHTML={{ __html: response?.Return_Message ?? "" }} />);
      } else {
        toast.success(<div dangerouslySetInnerHTML={{ __html: "Votre demande de correction a bien été prise en compte." }} />);
      }
      //refetchNoticeDemande();

      if (suppression) {
        navigate(`${pathSource}`, { replace: true }); 
      } else {
        if (idDemandeValue>0) {
          navigate(`${pathSource}/noticedetailsmodifauto/${eanValue}/${idNoticeValue}/${response?.Demande?.Id}`, { replace: false });
      } else {
        navigate(`${pathSource}/noticedetailsmodifauto/${eanValue}/${idNoticeValue}`, { replace: true });
      }
      }
      

    
      // if (!champs || champs?.length === 0 ) {
      
      // } else {
      // 
      // }

      
    }

  }

  const onSubmit = async (data: IFormNoticeModifAuto) => {
    const champs: INoticeDemandeChampCreateUpdate[] = [
      ...(data.hauteurNew ? [{ LibelleChamp: "hauteur", ValeurActuelle: data.hauteur ?? "", ValeurDemande: data.hauteurNew.replace(".",",") }] : []),
      ...(data.largeurNew ? [{ LibelleChamp: "largeur", ValeurActuelle: data.largeur ?? "", ValeurDemande: data.largeurNew.replace(".",",") }] : []),
      ...(data.epaisseurNew ? [{ LibelleChamp: "epaisseur", ValeurActuelle: data.epaisseur ?? "", ValeurDemande: data.epaisseurNew.replace(".",",") }] : []),
      ...(data.poidsNew ? [{ LibelleChamp: "poids", ValeurActuelle: data.poids ?? "", ValeurDemande: data.poidsNew.split(".")[0].split(",")[0] }] : []),
      ...(data.nbpagesNew ? [{ LibelleChamp: "nbpages", ValeurActuelle: data.nbpages ?? "", ValeurDemande: data.nbpagesNew }] : []),
      ...(data.disponibiliteNew ? [{ LibelleChamp: "disponibilite", ValeurActuelle: data.disponibilite ?? "", ValeurDemande: data.disponibiliteNew }] : []),
      ...(data.prixttcNew ? [{ LibelleChamp: "prixttc", ValeurActuelle: data.prixttc ?? "", ValeurDemande: data.prixttcNew.replace(".",",") }] : []),
      ...(data.dateparutionNew ? [{ LibelleChamp: "dateparution", ValeurActuelle: data.dateparution ?? "", ValeurDemande: format(data.dateparutionNew,formatDate2) }] : [])
    ];

      CreateUpdateNoticeDemande(champs,false);
  };



  if (errorCreateUpdateNoticeDemandeMutation) {
    //
  } 
  
  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };

  const deleteHandler = () => {
    setDialogOpen(true); // Ouvrir le modal de confirmation
  };
  
  const handleConfirm = () => {
    setDialogOpen(false);

    let resetValues = {};
    resetValues = {
      ...resetValues,
      hauteurNew:  "",
      largeurNew:  "",
      epaisseurNew:  "",
      poidsNew: "",
      nbpagesNew:  "",
      disponibiliteNew:"",
      prixttcNew: "",
      dateparutionNew:  ""
    };

    reset(resetValues);
    CreateUpdateNoticeDemande([],true);
  };
  
  const handleCancel = () => {
    setDialogOpen(false);
  };

  const getNavigator = () => {
    return (
    <div className="col-3 mt-2 d-flex justify-content-end">
      <div className="me-2">
        { eanValue !== undefined && idNoticeValue !== undefined && idDemandeValue !== undefined &&
      <CpntNavigatorNotice
      currentValueEan={eanValue} 
      currentValueIdNotice={idNoticeValue}
      currentValueIdDemande={idDemandeValue?.toString()}

      datas={(() => {
        const storedData = localStorage.getItem("NoticesNavigator");
        try {
          const parsedData = storedData ? JSON.parse(storedData) : [];
          return Array.isArray(parsedData) ? parsedData : [];
        } catch {
          return [];
        }
      })()}
      />
    }
      </div>
    </div>
    )
  }


  const getNonAccessibleNoticePart = (message?: string) => {
    return (
      <div className="container">
      <div className="row">
        <div className="col-9 mt-2 d-flex justify-content-start">
          <div className="row">
            <div className="col-12 mt-2 d-flex justify-content-start">
              
            </div>
            <div className="col-12 mt-2 d-flex justify-content-start">
              
            </div>
          </div>
        </div>
        {getNavigator()}
      </div>
      <CpntDetailsNotAccess text={message} typeAffichage={TypeAffichage.Notice} />
    </div>
    )
  }

  const getNonAccessibleFormPart = (jsxContent?: JSX.Element) => {
    return (
      <div className="container">
      <div className="card pae-detail-pub-card mt-2 alert alert-danger" role="alert">
          <div className="card-body pae-form-container row">
            <div className="col-12">
              {jsxContent}
            </div>
          </div>
      </div>
    </div>
    )
  }
  
  const SuppressionDialog = (
    <ConfirmDialog
        title="Confirmer la suppression"
        message="La demande va être supprimée"
        isOpen={isDialogOpen}
        button1Libelle="Annuler"
        button2Libelle="Confirmer"
        button1ClassName="btn-darkgrey"
        button2ClassName="btn-red btn"
        onButton1={handleCancel}
        onButton2={handleConfirm}
      />);
      
  return (
    !NoticeResult || isFetchingNotice ?
    <SpinnerEditeurPro />
    :
    <>
      {
      (NoticeResult?.Return_IdType_Message === Type_Return_Message.Erreur)?
      getNonAccessibleNoticePart("Cette demande est rattachée à une notice qui ne fait plus partie de votre périmètre de consultation")
      :
      // ModificationAutoBloqueMessage !== undefined ? 
      // getNonAccessiblePart(undefined,ModificationAutoBloqueMessage)
      // :
      <>
      <div className="container">
        <div className="row">
          <div className="col-9 mt-2 d-flex justify-content-start">
            <div className="row">
              <div className="col-12 mt-2 d-flex justify-content-start">
                {<>Date de la demande de modification :&nbsp;<b>{demande?.Demande?.DateMaj ? demande?.Demande?.DateMaj?.toString().replace('T',' à ') : 'pas de demande en cours.'}</b></>}
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start">
                {<>Votre contact :&nbsp;<b>{notice?.SuiviPar ? notice?.SuiviPar : 'biblio@electre.com'}</b></>}
              </div>
            </div>
          </div>
          {getNavigator()}
        </div>
          {!Actif ? 
            <>
                <div className="row">
                    <div className="col-12 mt-2">
                      <NoticeDetailsPreview NoticeResult={notice} isFetchingNoticeResult={isFetchingNotice} btnModifierAutoVisible={false} btnModifierMessageVisible={idDemandeValue > 0 ? false : true} ></NoticeDetailsPreview>
                    </div>
                </div>
                <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                  <div className="row">
                      <i className="col-12 bi-caret-down-fill"></i>
                  </div>
                </div>
            </> 
            :  
            <>
             {/* navigatorPath="../noticedetails/noticedetailsmodifauto/" */}
              <NoticeDetails NoticeResult={notice} isFetchingNoticeResult={isFetchingNotice} btnModifierAutoVisible={false} btnModifierMessageVisible={idDemandeValue > 0 ? false : true} ></NoticeDetails>
              <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                <div className="row">
                    <i className="col-12 bi bi-caret-up"></i>
                </div>
              </div>
            </>
          }
        </div>
        {
          ModificationAutoBloqueMessage !== undefined ? 
          getNonAccessibleFormPart(ModificationAutoBloqueMessage)
          :
      <div className="row mt-2" style={{ textAlign: 'left' }}>
        {demandeBloque &&
            <div className="offset-2 col-8">
            <div className="row">
              {demandeIdEtat === Notice_Demande_Modification_Etat.Encoursdetraitement && 
              <>
                       <i className="col-2 bi bi-exclamation-square-fill text-orange fs-2 text-end"></i>
                       <span className="col-8 text-center">Une demande est en cours de traitement.<br />Merci de patienter avant de faire une nouvelle demande</span>
                       <i className="col-2 bi bi-exclamation-square-fill text-orange fs-2 text-start"></i>
                       </>
              }
              {demandeIdEtat === Notice_Demande_Modification_Etat.Traite && 
              <>
                       <i className="col-2 bi bi-check-square-fill text-green fs-2 text-end"></i>
                       <span className="col-8 text-center">La demande a bien été traitée.</span>
                       <i className="col-2 bi bi-check-square-fill text-green fs-2 text-start"></i>
                       </>
              }
              {demandeIdEtat === Notice_Demande_Modification_Etat.Erreur && 
              <>
                       <i className="col-2 bi bi-x-square-fill text-reddark fs-2 text-end"></i>
                       <span className="col-8 text-center">La demande est en erreur.<br />Merci de vous rapprocher de votre chargé(e) de relations éditeurs.</span>
                       <i className="col-2 bi bi-x-square-fill text-reddark fs-2 text-start"></i>
                       </>
              }
              </div>
          </div>
        }
      {!demande || isFetchingNoticeDemande ?
      <SpinnerEditeurPro />
      :
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
          <CpntFormSection pSectionLabel="">
            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12]}>
                <div className="card pt-1 pb-1 ps-2 pe-2">
                {notice?.LivreEnMain && (
                      <div className="mt-3">
                        <div className="text-danger fw-bold text-center">
                          <i className="bi bi-exclamation-triangle"></i> Ouvrage contrôlé &quot;livre en main&quot; par Electre. Pour toute demande sur ces champs, merci d&apos;utiliser le formulaire de message.
                        </div>
                      </div>
                    )}
                  <div className="card-body">
                    <div className="row text-start" >
                      <div className="col-12 p-2 mt-2 bg-grey rounded-top">
                        <b className="bi bi-rulers">&nbsp;Description physique</b>
                      </div>
                    </div>
                    <div className="row row-cols-3 bg-secondary-ng text-white rounded-top mt-2">
                      <div className="col p-2 border">
                        Champs&nbsp;<i className="bi bi-body-text"></i>
                      </div>
                      <div className="col p-2 border">
                        Valeur Electre.com&nbsp;<i className="bi bi-check-circle"></i> 
                      </div>
                      <div className="col p-2 border">
                        Valeur demandée&nbsp;<i className="bi bi-clock-history"></i>
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Hauteur (cm)" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                      <TextInput label="" formName="hauteur" validationStyle={validationMode.none} placeholder="" disabled={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="hauteurNew" validationStyle={validationMode.none} placeholder="" disabled={demandeBloqueLivreEnMain||demandeBloque} />
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Largeur (cm)" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                      <TextInput label="" formName="largeur" validationStyle={validationMode.none} placeholder="" disabled={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="largeurNew" validationStyle={validationMode.none} placeholder="" disabled={demandeBloqueLivreEnMain||demandeBloque} />
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Epaisseur (cm)" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="epaisseur" validationStyle={validationMode.none} placeholder="" disabled={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="epaisseurNew" validationStyle={validationMode.none} placeholder="" disabled={demandeBloqueLivreEnMain||demandeBloque} />
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Poids (g)" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="poids" validationStyle={validationMode.none} placeholder="" disabled={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="poidsNew" validationStyle={validationMode.none} placeholder="" disabled={demandeBloqueLivreEnMain||demandeBloque} />
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Nombre de pages" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="nbpages" validationStyle={validationMode.none} placeholder="" disabled={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="nbpagesNew" validationStyle={validationMode.none} placeholder="" disabled={demandeBloqueLivreEnMain||demandeBloque} />
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div className="">
                <div className="card pt-1 pb-1 ps-2 pe-2 mb-4 ">
                  <div className="card-body">
                    <div className="row text-start " >
                      <div className="col-12 p-2 mt-2 bg-grey rounded-top">
                        <b className="bi bi-shop-window">&nbsp;Données commerciales</b>
                      </div>
                    </div>
                    <div className="row row-cols-3 bg-secondary-ng text-white rounded-top mt-2">
                      <div className="col p-2 border">
                        Champs&nbsp;<i className="bi bi-body-text"></i>
                      </div>
                      <div className="col p-2 border">
                        Valeur Electre.com&nbsp;<i className="bi bi-check-circle"></i> 
                      </div>
                      <div className="col p-2 border">
                        Valeur demandée&nbsp;<i className="bi bi-clock-history"></i>
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Disponibilité" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                      {/* <TextInput label="" formName="disponibilite" validationStyle={validationMode.none} placeholder="" disabled={true} /> */}
                      <SelectInput
                        label=""
                        formName="disponibilite"
                        ismandatory={true}
                        options={
                          disponibiliteList.map((d) => {
                          return {
                            Id: d.Id,
                            Libelle: d.Libelle,
                          };
                        })}
                        optionEmpty="-"
                        disabled={true} 
                      />
                      </div>
                      <div className="col p-2 border">
                      <SelectInput
                        label=""
                        formName="disponibiliteNew"
                        ismandatory={true}
                        disabled={demandeBloque}
                        options={disponibiliteList.map((d) => {
                          return {
                            Id: d.Id,
                            Libelle: d.Libelle,
                          };
                        })}
                        optionEmpty="-"
                      />
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Prix TTC" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="prixttc" validationStyle={validationMode.none} placeholder="" disabled={true} />
                      </div>
                      <div className="col p-2 border">
                        <TextInput label="" formName="prixttcNew" validationStyle={validationMode.none} placeholder="" disabled={demandeBloque} />
                      </div>
                    </div>
                    <div className="row row-cols-3">
                      <div className="col p-2 border">
                      <Label label="Date de parution" ismandatory={true} />
                      </div>
                      <div className="col p-2 border">
                      <DatePickerInput
                        formName="dateparution"
                        label=""
                        ismandatory={true}
                        disabled={true}
                        showTimeSelect={false}
                        //setValue={setValue}
                        // extraOnChange={() => setNewDate(getValues("DateFin").toISOString())}
                        // error={errorDateFin}
                      />
                      </div>
                      <div className="col p-2 border">
                      <DatePickerInput
                        formName="dateparutionNew"
                        label=""
                        ismandatory={true}
                        disabled={demandeBloque}
                        //setValue={setValue}
                        // extraOnChange={() => setNewDate(getValues("DateFin").toISOString())}
                        // error={errorDateFin}
                      />
                      </div>
                    </div>
                  </div> 
                </div>
                <div className="row pt-1 pb-1 ps-2 pe-4">
                {!demandeBloque &&
              <>
                <div className="col-6">
                      {demande && demande?.Demande?.Champs?.length > 0 &&
                        <>
                          <Button type="button" className="btn-red col-12" onClick={deleteHandler}>
                            Supprimer la demande
                          </Button>
                          {SuppressionDialog}
                        </>
                      }
                </div>
                <div className="col-6">
                <Button type="submit" className="btn-secondary col-12" disabled={!isValid}>
                  Enregistrer la demande
                </Button>
                </div>
              </>
              }
              </div>
            </div>
                
            </CpntFormSectionContainer>
          </CpntFormSection>
        </form>
      </FormProvider>
      }
      </div>
    } 
      </>
      
      }
    </>
  );

  
};
 
export default PageNoticeDetailsModifAuto;
 